import {Dispatch, SetStateAction} from 'react';
import {
  chakra,
  Box,
  Container,
  Text,
  Accordion
} from '@chakra-ui/react';
import StepSectionHeading from '../components/StepSectionHeading';
import Dividuals from '../components/Dividuals';
import StepExamples from '../components/StepExamples';

type Props = {
  estates: Estate[],
  setEstates: Dispatch<SetStateAction<Estate[]>>
};

export default function Ratios({
  estates,
  setEstates
}: Props) {
  const setEstate = (index: number, estate: Estate) =>
    setEstates(prev => [
      ...prev.slice(0, index),
      estate,
      ...prev.slice(index + 1)
    ]);

  return (
    <chakra.section mt={[`${177/16}rem`, `${177/16}rem`, `${285/16}rem`]}>
      <StepSectionHeading number={2}>
        <Box maxW={['contentSm', 'contentSm', 'content']} mx="auto">
          分人の“構成比率”を
          <br />
          考えてみましょう
        </Box>
      </StepSectionHeading>
      <Container maxW={['contentSm', 'contentSm', 'content']} px={0}>
        <Box mt={[8, 8, `${67/16}rem`]} lineHeight={[1.5, 1.5, 2]}>
          <Text>STEP1で入力した “分人を振り返ってみたい時期”それぞれを思い返して、どのような「分人」があったかを書き出してみましょう。次に、その「分人」ごとの構成比率を入力してみましょう。</Text>
        </Box>
        <StepExamples
          examples={[
            '対人関係ごとの「分人」を書き出してみる',
            '趣味などのモノやコトに対する「分人」を書き出してみる'
          ]}
          mt={[9, 9, `${134/16}rem`]}
        />
        <Accordion defaultIndex={[0]} allowMultiple mt={[14, 14, "10"]}>
          {estates.map((estate, index) => 
            <Dividuals key={estate.id} estate={estate} setEstate={estate => setEstate(index, estate)} estates={estates} mt={index === 0 ? 0 : ['1.5rem', '1.5rem', '1.875rem']} />)}
        </Accordion>
      </Container>
    </chakra.section>
  );
}
